/// <reference path="common.module.ts" />

module Meevo.Components.Common {


    export class IdentityService implements IIdentityService {
        private identity: IIdentity;

        current(): IIdentity {
            return this.identity;
        }

        get isAuthProviderJcp(): boolean {
            return (this.identity && this.identity.authProviderName) ? this.identity.authProviderName.toUpperCase().indexOf('JCP') > -1 : false;
        }

        get isJcpTenant(): boolean {
            return this.identity.tenantId === Model.TenantTypeEnum.JcPenney;
        }

        get isMeTenant(): boolean {
            return this.identity.tenantId === Model.TenantTypeEnum.Me;
        }

        inTestOrTrainingMode(): boolean {
            return Model.Guard.isSomething(this.identity.systemSettings) &&
                (this.identity.systemSettings.isTestingEnvironment ||
                this.identity.systemSettings.isTrainingEnvironment);
        }

        inCallCenterMode(): boolean {
            return Model.Guard.isSomething(this.identity.callCenterId)
                && this.identity.callCenterId === this.identity.locationId;
        }

        inCentralOfficeMode(): boolean {
            return Model.Guard.isSomething(this.identity.centralOfficeId)
                && this.identity.centralOfficeId === this.identity.locationId
                && !this.identity.isSingleLocation;
        }
        inSandboxMode(): boolean {
            return Model.Guard.isSomething(this.identity.isSandbox)
        }
        isUserHasBusinessTypeIds(): boolean {
          return Model.Guard.isSomething(this.identity.centralOfficeId)
                && this.identity.centralOfficeId === this.identity.locationId
                && this.userBusinessTypes.length > 0;
        }

        isSingleLocation(): boolean {
            return this.identity.isSingleLocation;
        }

        checkCentralOfficeLocationId(locId: number): boolean {
            return (this.identity.centralOfficeId === locId);
        }


        get businessTypeId(): string {
            return this.identity.businessTypeId;
        }

        get locationId(): number {
            return this.identity.locationId;
        }

        get tenantName(): string {
            return this.identity.tenantName;
        }
        get userBusinessTypes(): Model.DataDetail[] {
            var dDUserBusinessTypeList: Model.DataDetail[] = [];
            var dDBusinessType: Model.DataDetail = {};
            _.each(this.identity.userBusinessTypeIds, (DisplayName, Id) => {
                dDBusinessType = { id: Id.toString(), displayName: DisplayName.toString() };
                dDUserBusinessTypeList.push(dDBusinessType);
            });
            return dDUserBusinessTypeList;
        }

        get tenantBusinessTypeCount() {
            return this.identity.tenantBusinessTypeCount;
        }

        loggedInUserId(): Guid {
            return this.identity.userId;
        }

        setIdentity(identity: IIdentity): void {
            this.initialize();
            this.identity = identity;
            if (!identity) {
                // Logging out
                this.clearToken();
            }
        }

        public clearToken(): void {
            const win = window as any;
            win.bearerToken = null;
            sessionStorage.removeItem('mil:meevo:token');
        }

        public setToken(jwt: string): void {
            const win = window as any;
            win.bearerToken = jwt;
            sessionStorage.setItem('mil:meevo:token', jwt);
        }

        get isEmulating(): boolean {
            return (this.identity.effectiveCallCenterId && this.identity.effectiveCallCenterId > 0)
                || (this.inCallCenterMode() 
                    && this.identity.asImpersonateLocationId
                    && this.identity.asImpersonateLocationId > 0);
        }

        get emulationData(): IEmulationData {
            return {
                effectiveCallCenterId: this.identity.effectiveCallCenterId,
                asImpersonateLocationId: this.identity.asImpersonateLocationId,
                loggedInLocation: this.identity.locationId,
                userId: this.identity.userId
            }
        }

        get effectiveLocationId(): number {
            return !!this.identity.asImpersonateLocationId && this.identity.asImpersonateLocationId > 0
                ? this.identity.asImpersonateLocationId
                : this.identity.locationId;
        }

        isTollFreeNumberSupported(): boolean {
            return Model.Guard.isSomething(this.identity.systemSettings)
                && this.identity.systemSettings.isTollFreeNumberSupported;
        }

        private initialize(): void {
            sessionStorage.removeItem(Constants.SS_LOCATION_SEARCH_CRITERIA);
            sessionStorage.removeItem(Constants.SS_LOCATION_OVERRIDE);
        }

        static factory(): Function {
            let svc = () => {
                return new IdentityService();
            }

            return svc;
        }
    }


    angular.module("meevo.components.common")
        .factory("meevo.components.common.IdentityService", IdentityService.factory());
}